import * as Sentry from '@sentry/browser';

(function () {
    ('use strict');
    ('ngInject');

    angular.module('app.ctrls').controller('CreateTemplateCtrl', createTemplateCtrl);

    function createTemplateCtrl($scope, $rootScope, $timeout, $mdDialog, $location, UsersAPIService, blockUI) {
        const templates = {
            COUPLE_MUG: 1,
            PHONE: 2,
            DOG_MUG: 3,
            FAMILY_CANVAS: 4,
            METAL_SIGN: 5,
            TOTE: 6,
            NOTEBOOK: 7
        };
        $scope.loading = true;

        blockUI.start('Creating Template');
        UsersAPIService.createTemplate($location.search().productId)
            .then((response) => {
                blockUI.stop();
                $rootScope.shopifyProductUrl = response.ProductUrl;
                const id = parseInt($location.search().productId);

                if (templates.COUPLE_MUG === id) $location.path('/createdProduct/couplemug');
                else if (templates.PHONE === id) $location.path('/createdProduct/phone');
                else if (templates.DOG_MUG === id) $location.path('/createdProduct/dogmug');
                else if (templates.FAMILY_CANVAS === id) $location.path('/createdProduct/familycanvas');
                else if (templates.METAL_SIGN === id) $location.path('/createdProduct/metalsign');
                else if (templates.TOTE === id) $location.path('/createdProduct/tote');
                else if (templates.NOTEBOOK === id) $location.path('/createdProduct/notebook');
            })
            .catch((error) => {
                window.rumReportError(error);
                $timeout(() => $scope.$apply());
                blockUI.stop();

                $mdDialog.show(
                    $mdDialog
                        .alert()
                        .parent(document.body)
                        .clickOutsideToClose(true)
                        .title('Error creating template: ' + error.statusText)
                        .ok('Ok')
                );
            });

        window.Appcues?.on('flow_completed', function (event) {
            if ($rootScope.shopifyProductUrl) {
                window.open($rootScope.shopifyProductUrl, '_blank');
            }
        });
    }
})();
